import React from "react";
import "./ContactHire.scss";
import {useFixedHeader} from "../../../../utils/headerHelper";
import {SubmitInfo} from "../../../../components/SubmitInfo/SubmitInfo";
import {BlackModal} from "../../../../components/BlackModal/BlackModal";
import {FooterFixed} from "../../../../components/FooterFixed";

export function ContactHire() {

    useFixedHeader();

    return <>
        <main className="main-content">
            <header
                className="page-header large image-background about-us-header-bg dark-color center no-padding"
                data-stellar-background-ratio="0.3">
                    <div className="container v-align-center">
                        <div className="row">
                            <div className="col-md-12">
                                <h1 className="x-large">招聘信息</h1>
                                <div>
                                    <i className="icon-glyph-10 medium"></i><i className="icon-glyph-10 medium"></i><i
                                    className="icon-glyph-10 medium"></i><i className="icon-glyph-10 medium"></i><i
                                    className="icon-glyph-10 medium"></i>
                                </div>
                            </div>
                        </div>
                    </div>
            </header>

            <section className="pt-small light-color">
                <div className="container">
                    <div className="hire-box">
                        <h2>电子工程师<span>工作经验：3-5年·本科以上学历</span></h2>
                        <div className="row">
                            <div className="col-md-6">
                                <h3>岗位职责：</h3>
                                <p>
                                    1、项目负责人，负责产品的研发设计，包括电路设计、测试、技术文档编写；<br/>
                                    2、承担新产品的设计工作（包括硬件、软件及各种计算、实验、图纸、说明书等）；<br/>
                                    3、负责批量生产过程中产品的技术支持及设计更改工作。
                                </p>
                            </div>
                            <div className="col-md-6">
                                <h3>任职资格：</h3>
                                <p>
                                    1、电子工程、电气工程、自动化专业本科及以上学历； <br/>
                                    2、能熟练使用计算机辅助设计工具；<br/>
                                    3、熟悉新产品的开发流程，能完成新产品开发工作；<br/>
                                    4、熟悉单片机开发，有电机开发经验；<br/>
                                    5、熟悉EMC、安规，有一定的英语阅读能力；<br/>
                                    6、有2年以上的医疗器械行业经验，牙科行业更佳。
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="hire-box">
                        <h2>市场专员<span>工作经验：1-3年·本科</span></h2>
                        <div className="row">
                            <div className="col-md-6">
                                <h3>岗位职责：</h3>
                                <p>
                                    1、负责官网基础运营工作，包括网站策划和内容策划/维护等；<br/>
                                    2、承担互联网营销平台基础搭建与日常维护，包括回复客户询盘、潜在客户分析、网络控价等；<br/>
                                    3、负责产品宣传软文、宣传彩页、新闻事件、用户案例、培训资料、促销活动等文案的整理撰写；<br/>
                                    4、负责官微、微博、朋友圈、公众号等自媒体端文案撰写及信息维护；<br/>
                                    5、配合其他部门完成相关文案的整理撰写工作。<br/>
                                </p>
                            </div>
                            <div className="col-md-6">
                                <h3>任职资格：</h3>
                                <p>
                                    1、大专以上学历，能熟练掌握作图软件； <br/>
                                    2、有美工及电商方面的工作经验优先；<br/>
                                    3、具有较强的工作责任心和良好的职业道德，无不良记录。<br/>
                                </p>
                            </div>
                        </div>


                    </div>
                    <div className="hire-box">
                        <h2>机械结构模具工程师<span>工作经验：1-3年·本科</span></h2>
                        <div className="row">
                            <div className="col-md-6">
                                <h3>岗位职责：</h3>
                                <p>
                                    1、配合电子总工程师完成产品的结构研发设计、加工、装配和调试；<br/>
                                    2、负责产品结构的出图并与模具厂进行沟通； <br/>
                                    3、解决产品设计过程中的问题及技术改进工作。
                                </p>
                            </div>
                            <div className="col-md-6">
                                <h3>任职资格：</h3>
                                <p>
                                    1、本科以上学历，机械设计、机械一体化、自动化等相关专业； <br/>
                                    2、熟悉机械加工工艺和产品结构设计； <br/>
                                    3、熟练运用SolidWorks三维制图软件、AutoCAD制图软件；<br/>
                                    4、责任心及抗压能力强，有团队合作精神； <br/>
                                    5、有较强的系统设计、开发和沟通理解能力；<br/>
                                    6、熟悉专利申请优先。
                                </p>
                            </div>
                        </div>


                    </div>
                    <div className="hire-box" style={{borderBottom: "none"}}>
                        <h2>外贸销售专员<span>工作经验：1-3年·本科 </span></h2>
                        <div className="row">
                            <div className="col-md-6">
                                <h3>岗位职责：</h3>
                                <p>
                                    1、承担互联网营销平台日常维护，包括回复客户询盘、潜在客户分析、网络控价等；<br/>
                                    2、利用阿里巴巴等各种平台开拓海外市场，及时回复客户询盘和后期的跟进工作；<br/>
                                    3、参加国内外行业内的各种展会，利用展会开发国外客户，能适应国外出差；<br/>
                                    4、掌握国外客户需求，维护老客户，开发新客户，合理报价，完成上级下达的任务指标。
                                </p>
                            </div>
                            <div className="col-md-6">
                                <h3>任职资格：</h3>
                                <p>
                                    1、英语或者国际贸易相关专业本科以上学历；（本科以下学历的要求有两年以上外贸工作经验或者口语能力突出者优先） <br/>
                                    2、英语至少四级以上，口语流利具备较强的英语阅读与书写能力，能和国外客户进行有效和良好的沟通；<br/>
                                    3、精通阿里巴巴及中国制造等网络销售推广平台，有相关工作经验者优先；<br/>
                                    4、具备良好的业务拓展能力和商务谈判技巧，公关意识强；<br/>
                                    5、性格开朗，乐于交流，喜欢挑战；<br/>
                                    6、独立意识强，有医疗行业工作经验的优先。
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <div className="reward">
                <h1>福利待遇</h1>
                <h2 style={{marginBottom: "50px"}}>五险一金、大小周休假、国家法定节假日、出国的机会，待遇面议，欢迎有能力的小伙伴加入我们团队！</h2>
                <p>广州瑞柏安医疗器械有限公司</p>
                <p>广州南沙经济技术开发区兴业路2号易事达高新科技园E栋309室</p>
                <p>联系人：朱小姐 | 联系方式：13316199286 | 电话：020-31062832</p>
            </div>
            <SubmitInfo/>
            <BlackModal/>
        </main>
        <FooterFixed/>
    </>
}